import { render, staticRenderFns } from "./DataPurposeModal.vue?vue&type=template&id=960104bc"
import script from "./DataPurposeModal.vue?vue&type=script&lang=js"
export * from "./DataPurposeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports